// extracted by mini-css-extract-plugin
module.exports = {"optionButton":"OptionButton_optionButton__JXfiX","disabled":"OptionButton_disabled__tj6_h","spinner":"OptionButton_spinner__8xh3m"};